import {forwardRef} from 'react';
import {Input} from '../../atoms/Input/Input';
import {InputFieldProps} from './InputFieldProps.interface';

/**
 * 인풋필드 - 일반입력에 해당합니다. 디자인팀에서 컨텍스트 포함 없이 범용적으로 사용한다고 전달받았기 떄문에 Molecule로 만들었습니다.
 *
 */
export const InputField = forwardRef<HTMLInputElement, InputFieldProps>(
  (props, ref) => {
    return (
      <div className="flex h-48pxr w-full items-center rounded-3pxr border-1 border-solid border-theme-transparent-20 px-12pxr">
        <Input {...props} ref={ref} />
      </div>
    );
  }
);

InputField.displayName = 'InputField';
